import { createAsyncThunk } from '@reduxjs/toolkit';
import NotificationsAPI from './notificationAPI';


/**
 * Thunks
 */
export const fetchUserNotifications = createAsyncThunk(
  'notifications/fetchUserNotifications',
  async (userId, { rejectWithValue }) => {
    try {
      const data = await NotificationsAPI.fetchAll(userId);
      return { userId, notifications: data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to fetch notifications.');
    }
  }
);

export const sendUserNotification = createAsyncThunk(
  'notifications/sendUserNotification',
  async ({ userId, notificationData }, { rejectWithValue }) => {
    try {
      const data = await NotificationsAPI.send(userId, notificationData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to send notification.');
    }
  }
);

export const markNotificationAsRead = createAsyncThunk(
  'notifications/markNotificationAsRead',
  async ({ userId, notificationId }, { rejectWithValue }) => {
    try {
      return await NotificationsAPI.markSingleRead(userId, notificationId);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to mark notification as read.');
    }
  }
);

export const markAllNotificationsAsRead = createAsyncThunk(
  'notifications/markAllNotificationsAsRead',
  async (userId, { rejectWithValue }) => {
    try {
      return await NotificationsAPI.markAllRead(userId);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to mark all notifications as read.');
    }
  }
);

export const getUnreadNotificationCount = createAsyncThunk(
  'notifications/getUnreadNotificationCount',
  async (userId, { rejectWithValue }) => {
    try {
      const unreadCount = await NotificationsAPI.getUnreadCount(userId);
      return { userId, unreadCount };
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to get unread notification count.');
    }
  }
);